<template>
  <div>
    <div class="content contentTerms">
      <div class="mainDiv">
        <article class="main">
          <section class="topTitle">
            <img src="/static/img/work/argreementLogo.png" alt="">
            薄盒用戶協議
          </section>
          <section class="intro bold">
            <h4 style="margin-bottom: 5px; ">尊敬的用戶（“您”）：</h4>
            <p style="word-break: break-all;">
              歡迎您使用薄盒平台（包括薄盒APP和薄盒官方網站https://mintstech.cn/，以下簡稱“本平台”），本平台由北京擘盒科技有限公司（以下簡稱“我們”）運營。本平台是一款為用戶提供購買、收集和展示區塊鏈數字藏品（登記在區塊鏈上，由各領域的頂尖藝術家創作、限量發行的數字藝術收藏品。以下簡稱“數字藏品”）的平台。使用我們的服務前請您仔細閱讀以下條款，使用我們的服務則表明您已知悉並接受這些條款（以下簡稱“本協議”）。若您不接受有關條款和條件的約束，請立即停止使用我們的服務。
              <br />
              任何未滿18周歲的未成年人或不具備完全民事行為能力之人均不得註冊賬號或使用我們提供的服務。 </p>
          </section>
          <section class="privacy-content">
            <ul>
              <li>
                <div class="rt">
                  <p>一、簽約主體以及協議範圍</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>1.1協議主體及範圍</p>
                        <p class="desc" style="word-break: break-all;">
                          本協議是您與我們就使用本平台（https://mintstech.cn/）服務而共同訂立的協議。 <br>
                          本協議條款的效力及於我們所提供的一切產品和服務，您在享受本平台任何服務時，應當受本協議的約束。本協議項下的產品和服務是指由我們發布的包括但不限於網絡媒體、互聯網增值、互動娛樂、電子商務、廣告等互聯網產品和服務（形式包括但不限於視頻、音頻、評論、跟帖、彈幕、圖片、軟件、技術代碼等）。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.2訂立前提</p>
                        <p class="desc"><span
                            class="bold">數字藏品是數字化的收藏品，您在此承諾並保證，您主要將本平台上的數字藏品用作收藏、娛樂和遊戲的對象，而不是用於投資、投機或炒作；您在此承諾並保證，您將主要將實物收藏品的區塊鏈數字證書作為防偽溯源的工具，而不是用於投資、投機或炒作，該等承諾與保證將作為您與我們訂立本協議的前提。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.3免責條款</p>
                        <p class="desc"><span
                            class="bold">為了讓您更好地使用我們提供的產品和服務，請您務必審慎閱讀、充分理解本協議各條款內容，特別是免除或者限制責任的條款。本協議中限制、免責條款可能以加粗形式提醒您注意。
                            <br>當您註冊/登錄本平台，即視為您已充分閱讀並接受本協議的所有條款，您同意本協議對您與我們雙方具有法律約束力。
                          </span></p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>1.4協議組成部分</p>
                        <p class="desc">
                          除本協議明確規定外，對於我們發布的由著作權人或其他權利人銷售的產品和服務，我們有權在本協議的基礎上通過單獨的產品和服務協議（以下簡稱“單項產品協議”）加以規範，您須在使用有關產品或服務時另行了解與確認。單項產品協議與本協議有衝突的地方，以單項產品協議為準。如您使用該產品或服務，即視為對相關單項產品協議的接受。
                          <br />
                          本協議內容同時包括所有我們已經發布或未來可能發布的各類規則、公告或通知，以及您在使用某一特定產品或服務時同意的單項產品協議，前述規則、公告、通知和單項產品協議一經發布即為本協議不可分割的組成部分，對您和我們雙方具有法律約束力。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p>1.5協議的修訂</p>
                        <p class="desc">
                          <span class="bold">
                            我們有權根據需要不時地修訂本協議及/或各類規則（包括但不限於製定新的條款和修改既有條款），一旦發生變動，我們將盡可能及時地在平台上以在線公告的方式進行變更公告，而無須另行單獨通知您。修訂後的協議和規則一經公佈，立即或在公告明確的特定時間生效。若您在前述公告修訂後繼續使用我們的產品或服務，即視為您已閱讀、理解並接受經過修訂的協議和規則。若您不同意修訂，應當立即停止使用本平台。
                          </span>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>二、賬號的註冊、使用與安全</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>2.1註冊資格</p>
                        <p class="desc">
                          您確認，<span class="bold">您應當年滿18周歲並具備完全民事行為能力，方可註冊使用本平台。
                          </span>如果您不滿18周歲或不具有完全民事行為能力，您不應使用本平台，否則您及您的法定監護人應依照法律規定承擔因此而導致的一切後果。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.2賬號註冊</p>
                        <p class="desc">
                          您在註冊時應當使用手機號、短信驗證碼、郵箱、郵箱驗證碼和好友邀請碼，填寫暱稱、性別，以完成註冊。當您按照註冊頁面提示填寫信息、閱讀並同意本協議且完成全部註冊程序後，您可使用我們向您提供的賬號並成為我們的用戶。您的賬號是您用以登錄並使用我們服務、購買數字藏品的憑證<span
                            class="bold">但請您特別注意，我們僅許可您出於個人而非商業目的使用該賬號。我們保留該賬號以及與註冊、使用該賬號相關的服務數據和記錄的所有權，包括但不限於所有註冊、登錄、服務日誌、客服記錄和相關使用數據等。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.3賬號信息</p>
                        <p class="desc">
                          您應當按照法律法規要求或按相應頁面的提示，準確提供並及時更新您的賬號信息，以使之真實、及時、完整和準確，您須對所提供信息的真實性、合法性、有效性及完整性負責。如您提供的資料錯誤、不實、過時或不完整的，我們可以向您發出詢問及/或要求改正的通知，您應按照我們的要求配合提供或者更新相關信息和資料。
                          <span
                            class="bold">因您填寫的信息、資料不真實、不及時、不完整或不准確的，您應承擔您不能使用我們的賬號（不能註冊成功、或賬號被凍結、註銷）或在使用過程中部分功能受到限制的後果和損失。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.4暱稱</p>
                        <p class="desc">您可以對賬號設置暱稱，您設置的暱稱不得侵犯或涉嫌侵犯他人的合法權益。設置暱稱時遵守以下規定：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）不以黨和國家領導人或其他社會名人的真實姓名、字號、藝名、筆名註冊；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）不以國家機構或其他機構的名稱註冊；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）不註冊名稱不文明、不健康的賬號，或包含歧視、侮辱、猥褻類詞語的賬號；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）不註冊易產生歧義、引起他人誤解的賬號；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（5）不得危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（6）不得損害國家榮譽和利益的，損害公共利益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（7）不得煽動民族仇恨、民族歧視，破壞民族團結；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（8）不得破壞國家宗教政策，宣揚邪教和封建迷信；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（9）不得散佈謠言，擾亂社會秩序，破壞社會穩定；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（10）不得散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（11）不得侮辱或者誹謗他人，侵害他人合法權益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（12）不得違反憲法或法律法規規定；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（13）不得含有法律、行政法規禁止的其他內容。 </p>
                            </div>
                          </li>
                          <li>

                            <div class="rt">
                              <p class="bold">
                                如您設置的暱稱涉嫌侵犯他人合法權益或者含有法律、行政法規禁止的其他內容，我們有權拒絕或終止向您提供部分或全部軟件服務。我們對此不承擔任何責任，您將承擔因此產生的任何直接或間接損失及不利後果。
                              </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.5禁止外借</p>
                        <p class="desc bold">
                          您的賬號僅限於您本人使用，未經我們書面同意，禁止以任何形式贈與、借用、出租、轉讓、售賣或以其他方式許可他人使用該賬號。如果我們發現或者有合理理由認為使用者並非賬號初始註冊人，我們有權暫時或終止向該註冊賬號提供服務，並有權註銷該賬號，而無需向註冊該賬號的用戶承擔法律責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.6禁止惡意註冊</p>
                        <p class="desc">禁止惡意註冊賬號，包括但不限於頻繁、批量註冊賬號。如果我們發現或者有合理理由認為您有惡意註冊賬號的行為，我們有權拒絕您的惡意註冊，或註銷惡意註冊的賬號。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.7賬號保管</p>
                        <p class="desc">
                          您須妥善保管您的賬號，在任何情況下不向他人透露賬號。您需確保您在購買數字藏品和使用我們的服務後，以正確步驟離開本平台。您對以您註冊賬號的名義所從事的活動承擔全部法律責任，包括但不限於在本平台購買數字藏品、支付款項、信息披露、信息發布、網上點擊同意或提交各類規則協議等操作行為可能引起的一切法律後果。 <span
                            class="bold">  因您的行為或因其他因素致您賬號遭受攻擊、詐騙、盜竊等導致的賬號洩露的損失及後果，我們不承擔任何責任。 </span>
                           如發現他人未經授權使用您的賬號，您應立即通知我們，我們將協助您凍結賬號或進行其他安全設置。
                          <span class="bold"> 請您理解我們對您的請求採取行動需要合理時間，我們對在採取行動前已經產生的以及由您引發的後果（包括但不限於您的任何損失）不承擔任何責任。
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.8實名認證</p>
                        <p class="desc">為了您更好地使用我們的各項服務，保障您的賬號安全，我們可能要求您按相關法律法規規定完成實名認證及/或對您進行“了解你的客戶”調查，並要求您進一步提供相關資料。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>2.9賬號的凍結及申訴</p>
                        <p class="desc">如發生以下情況，我們有權凍結您的賬號（全部或部分權限或功能），並通過適當的方式和途徑通知您：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）違反本協議，以及數字藏品購買、展示和服務的相關規則、管理規範、服務說明以及其他使用協議/條款的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）違反國家法律、法規、政策、法律文書的規定的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）您遭到他人投訴，且對方已經提供了相關證據，而您未按照我們的要求提供相反證據的；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）我們根據合理分析判斷您的賬號操作存在異常、進行可疑交易或存在欺詐、洗錢的風險；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（5）為了保護我們及其他用戶的合法權益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（6）國家有權機關要求。 </p>
                            </div>
                          </li>
                        </ul>
                        <p class="desc">
                          <span class="bold">
                            若您的賬號被凍結，在解凍前您將暫時無法使用賬號購買數字藏品。我們有權不經通知隨時刪除相關違規內容，並視行為情節對違規賬號進行處理，處理方式包括但不限於警告、刪除部分或全部訂閱用戶、限製或禁止使用全部或部分功能、賬號封禁甚至註銷，並有權視具體情況而公告處理結果。
                          </span>
                        </p>
                        <p class="desc">
                          您可以通過申訴程序，向我們申請解除上述凍結。為了您的賬號安全，您應配合如實提供身份證明及相關資料，以及我們要求的其他信息或文件，以便我們進行核實和調查。我們有權決定是否同意您的申訴請求。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>三、賬號的註銷</p>
                  <p class="desc">
                    您有權主動註銷您的賬號，您可以通過本平台“關於我們”頁面提供的聯繫方式聯繫我們註銷您的賬號（但法律法規另有規定的或本政策另有約定的除外）。
                    <span class="bold">
                      一旦您註銷賬號，將無法登錄原賬號使用我們提供的產品和服務且自動放棄您已有的權益，因此請您謹慎操作。
                    </span>
                    <br />
                     在您的賬號被您主動註銷或由於違反上述第二條的約定被強制註銷後，將可能產生包括但不限於如下結果需要您自行承擔：</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>3.1賬號一旦註銷，您將無法登錄、使用該賬號，即您將無法再以此賬號登錄、使用、繼續使用本平台所有產品與服務；</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.2賬號一旦註銷，您曾通過該賬號登錄、使用的本平台的產品與服務下的所有內容、信息、數據、記錄及您已經購買的數字藏品將會被全部凍結，包括但不限於：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）該賬號購買的數字藏品或獲得的實物收藏品的數字證書；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）該賬號下的個人資料（例如：頭像、暱稱等）及綁定信息（例如：綁定手機號、郵箱等），以及該賬號下的您的其他個人信息。同時您亦不再享有《<a
                                  href="/publicAgreement?agreementCode=H5YSZC"
                                  style="color:#83878B;font-weight:bold">薄盒隱私政策</a>》中約定的您對個人信息的權利，但法律法規另有約定的除外；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）該賬號曾發表的所有內容（例如：文章、圖片、評論、互動等）；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）其他與該賬號相關的所有內容、信息、數據、記錄（例如：收藏等）。 </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.3您同意通過註銷賬號的方式放棄該賬號在使用本平台產品與服務期間已產生的但未消耗完畢的權益及未來的預期利益。即賬號一旦註銷，您在該賬號下的全部權益將會自動清除作廢，包括但不限於：
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              <p>（1）您尚未提現的賬戶餘額；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（2）您在本平台發布的內容未來的收益權益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（3）您在本平台的各類身份權益；</p>
                            </div>
                          </li>
                          <li>
                            <div class="rt">
                              <p>（4）其他已產生但未消耗完畢的權益或未來預期的收益。 </p>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          3.4您的賬號一旦註銷，將無法恢復，即使您在註銷後以相同手機號碼再次向我們申請註冊本平台賬號，此時該賬號將為全新的用戶賬號。因此，我們善意地提醒您在主動申請註銷前對需要備份的內容提前自行做好備份，對需要提現的餘額先行提現，對其他利益做出妥善安排，謹慎思考後做出註銷決定；
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.5賬號一旦註銷，您與我們曾簽署過的協議、文件等相應終止（但已約定繼續生效的或法律法規另有規定的除外）；</p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>3.6其他因賬號註銷（可能）產生的結果。 </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>四、我們的服務</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>4.1數字藏品瀏覽、關注、分享、展示</p>
                        <p class="desc">
                          在您瀏覽本平台過程中，我們為您提供了信息分類、關鍵詞檢索、篩選、關注、展示等功能，以更好地匹配您的需求。您可以對您感興趣的數字藏品進行瀏覽、關注、分享，並向他人展示您購買到的數字藏品。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.2購買盲盒</p>
                        <p class="desc">
                          盲盒由著作權人及相關權利人（以下稱“銷售方”）通過本平台發售，每個盲盒中包含的收藏品類型、收藏品數量不同，您可在盲盒詳情頁查看，但您將僅知曉數字藏品的類型和數量（例如：以視頻或照片形式呈現的藝術作品、設計作品、繪畫作品等），無法知曉具體的內容。銷售方有權自主決定盲盒的類型、價格、數量，每個盲盒發售的數量不同，售完為止。
                          <br />
                          您可以在平台上進入“盲盒”導航頁面，選擇發售中的盲盒，進入盲盒詳情，了解盲盒的類型等信息。等候室開放後您可以加入等候室，到達盲盒購買時間則進入排隊隊列，隊列輪到您後則可以購買盲盒。根據您購買盲盒的類型，您將收集到不同的數字藏品。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>4.3限時活動</p>
                        <p class="desc">您可以通過參與本平台的限時活動，或接受某些挑戰任務，收集活動或任務指定數字藏品，獲得對應的獎勵。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.4廣告營銷</p>
                        <p class="desc">
                          您在本平台提交信息（包括但不限於郵箱、電話、姓名等），即視為您同意我們自行或者委託第三方廣告商通過電子郵件、站內信、手機短信、電話等形式與您聯繫，向您發送簡報、廣告等商業推送。
                          <br />
                          您可以按照商業廣告信息中說明的退訂方式退訂廣告，也可以通過本平台“關於我們”頁面提供的聯繫方式聯繫我們取消廣告推送，但是不得採用未經我們許可的方式屏蔽、過濾廣告信息。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.5爭議處理</p>
                        <p class="desc">對於您通過平台購買的實物產品，其本身存在質量問題或其他爭議的，您可以向平台反應，由平台向您提供銷售方的聯繫方式，由您向銷售方維權。 <br>
                          對於您通過平台購買的數字藏品，或如果在使用我們的服務過程中發生爭議，您可以聯繫我們進行調解、協商和解決。您也可以向有關行政部門投訴或向本協議約定的管轄法院提起訴訟。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>4.6服務升級</p>
                        <p class="desc">
                          為增進用戶體驗、完善服務內容，我們將會改進、增強和進一步開發本平台的服務，您理解並同意，我們有權不向您特別通知而對本平台服務進行更新，或對本平台的部分功能進行改變或限制。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        4.7
                        對於您根據本協議、通過本平台購買的商品（包括數字藏品），您將有權利要求取得等額於您實際支付的全部價款的增值稅發票，並通過平台發起開票請求。平台將把您的開票請求反饋至實際銷售方。您認可並同意該發票將由實際的銷售方負責開具。
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>五、使用規範</p>
                  <p class="desc">
                    您有權享受本平台提供的互聯網技術服務和信息服務，通過本平台購買和展示數字藏品，或獲得實物收藏品的區塊鏈數字證書。
                    <br>
                    <span class="bold">
                      在您遵守本協議的前提下，我們授予您關於本平台有限的、不可轉讓的、非獨占的、可撤銷的、僅為個人用途的非商業性使用的權利。在任何情形下，我們的內容及服務僅被許可由您個人使用而不得被出售或轉讓。我們保留本協議未特別授予的所有權利。您在使用我們的服務過程中，必須遵循以下原則：
                    </span>
                  </p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          5.1您不得製作、複製、發布、傳播含有下列內容的信息或從事相關行為，也不得為製作、複製、發布、傳播含有下列內容的信息或從事相關行為提供便利。本條所述內容是指您使用本協議項下服務過程中所製作、上載、複製、發布、傳播的任何內容，包括但不限於賬號頭像、暱稱、評價等信息，或文字、語音、圖片、視頻、圖文等發送、回复或自動回复消息和相關鏈接頁面，以及其他使用賬號或本平台服務所產生的內容。
                        </p>
                        <ul>
                          <li>
                            <div class="rt">（1）反對憲法所確定的基本原則的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）危害國家安全，洩露國家秘密，顛覆國家政權，破壞國家統一的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）損害國家榮譽和利益的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）歪曲、醜化、褻瀆、否定英雄烈士事蹟和精神，以侮辱、誹謗或者其他方式侵害英雄烈士的姓名、肖像、名譽、榮譽的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）宣揚恐怖主義、極端主義或者煽動實施恐怖活動、極端主義活動的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽動民族仇恨、民族歧視，破壞民族團結的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）破壞國家宗教政策，宣揚邪教和封建迷信的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）散佈謠言，擾亂經濟秩序和社會秩序的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）散佈淫穢、色情、賭博、暴力、兇殺、恐怖或者教唆犯罪的；</div>
                          </li>
                          <li>
                            <div class="rt">（10）侮辱或者誹謗他人，侵害他人名譽、隱私和其他合法權益的；</div>
                          </li>
                          <li>
                            <div class="rt">（11）違反法律法規底線、社會主義制度底線、國家利益底線、公民合法權益底線、社會公共秩序底線、道德風尚底線和信息真實性底線的“七條底線”要求的。
                            </div>
                          </li>
                          <li>
                            <div class="rt">（12）相關法律法規或本協議、相關協議、規則等禁止的。 </div>
                          </li>
                        </ul>
                        <p class="desc">同時，您應當防範和抵制製作、複製、發布含有下列內容的不良信息：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）使用誇張標題，內容與標題嚴重不符的；</div>
                          </li>
                          <li>
                            <div class="rt">（2）炒作緋聞、醜聞、劣蹟等的；</div>
                          </li>
                          <li>
                            <div class="rt">（3）不當評述自然災害、重大事故等災難的；</div>
                          </li>
                          <li>
                            <div class="rt">（4）有性暗示、性挑逗等易使人產生性聯想的；</div>
                          </li>
                          <li>
                            <div class="rt">（5）展現血腥、驚悚、殘忍等致人身心不適的；</div>
                          </li>
                          <li>
                            <div class="rt">（6）煽動人群歧視、地域歧視等的；</div>
                          </li>
                          <li>
                            <div class="rt">（7）宣揚低俗、庸俗、媚俗內容的；</div>
                          </li>
                          <li>
                            <div class="rt">（8）可能引發未成年人模仿不安全行為和違反社會公德行為、誘導未成年人不良嗜好等的；</div>
                          </li>
                          <li>
                            <div class="rt">（9）其他對網絡生態造成不良影響的內容。 </div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.2不得利用我們的服務從事違法犯罪的活動，包括分裂國家、教唆他人犯罪、侵犯計算機安全系統、干擾或擾亂網絡服務等危害國家安全、欺詐、洗錢及從事或資助其他違法犯罪活動或有損社會公共利益的行為。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.3遵守本協議及所有相關的協議、規定和程序，同時也必須遵循與因特網有關的程序和慣例。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.4不得利用或針對我們的服務進行任何危害計算機網絡安全的行為，包括但不限於：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）非法侵入他人網絡、干擾他人網絡正常功能、竊取網絡數據等危害網絡安全的活動；</div>
                          </li>
                          <li>
                            <div class="rt">（2）提供專門用於從事侵入網絡、干擾網絡正常功能及防護措施、竊取網絡數據等危害網絡安全活動的程序、工具；</div>
                          </li>
                          <li>
                            <div class="rt">（3）明知他人從事危害網絡安全的活動的，為其提供技術支持、廣告推廣、支付結算等幫助；</div>
                          </li>
                          <li>
                            <div class="rt">（4）使用未經許可的數據或進入未經許可的服務器/賬號；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未經允許進入公眾計算機網絡或者他人計算機系統並刪除、修改、增加存儲信息；</div>
                          </li>
                          <li>
                            <div class="rt">（6）未經許可，企圖探查、掃描、測試本服務系統或網絡的弱點或其它實施破壞網絡安全的行為；</div>
                          </li>
                          <li>
                            <div class="rt">（7）企圖干涉、破壞本服務系統或平台的正常運行，故意傳播惡意程序或病毒以及其他破壞干擾正常網絡信息服務的行為；</div>
                          </li>
                          <li>
                            <div class="rt">（8）偽造TCP/IP數據包名稱或部分名稱。 </div>
                          </li>
                        </ul>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.5不得對本平台進行反向工程、反向彙編、編譯或者以其他方式嘗試發現本平台的源代碼。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.6不得提交、發布虛假信息；不得欺詐、強制、誘導其他用戶關注、點擊鏈接頁面或分享信息；不得使用機器人或自動化程序，以虛假或欺詐的方式創建賬號或購買數字藏品；不得冒充他人，使用他人的電子郵件地址創建賬號或購買數字藏品。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.7不得使用未經我們授權或許可的任何插件、外掛、系統或第三方工具對本服務的正常運行進行干擾、破壞、修改或施加其他影響。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.8您應當使用自有合法資金購買數字藏品。 </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.9不得通過非法方式購買數字藏品，例如：盜刷信用卡或者使用其他您無權使用的支付方式或機制；不得通過非法方式獲得實物收藏品的區塊鏈數字證書，例如：盜竊他人所有或占有的實物收藏品，並基於該實物收藏品獲得數字證書。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.10您的購買行為應當基於真實的消費、收藏需求，而非基於投資或投機目的，不得存在對數字藏品實施惡意購買、價格操縱或利用數字藏品進行洗錢等擾亂正常平台秩序的行為。基於維護平台秩序及平台安全的需要，我們發現上述情形時可主動執行關閉相關訂單等操作。
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.11不得將本平台的數字藏品作為購買其他資產的一般等價物或憑證。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.12不得在本平台之外購買任何本平台的其它用戶賬號或本平台出售的數字藏品。如果您以其他方式購買本平台出售的數字藏品，產生的法律後果由您自行承擔。 </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          5.13不得在本平台以外將數字藏品拆分成份額進行交易，不得採取集中競價、集合競價、連續競價、電子撮合、做市交易等方式交易數字藏品。不得在本平台以外將實物收藏品的數字證書進行交易、炒作，不得採取集中競價、集合競價、連續競價、電子撮合、做市交易等方式交易實物收藏品的數字證書。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.14請您保證對通過本平台製作、複製、上傳、發布、傳播、評論的任何內容（包括但不限於頭像、名稱、賬號介紹，或文字、圖片、音頻、視頻、鏈接等，以及其他使用本平台服務所產生的其他內容）享有合法權益，不得侵犯我們及我們關聯公司、或其他任何第三方的專利權、著作權、商標權等知識產權、名譽權、隱私權或其他任何合法權益，或從事損害我們利益或對我們造成不利影響的行為。 <span
                            class="bold">若您賬號中的內容髮生權利糾紛或侵犯了任何第三方的合法權益，您需承擔全部法律責任。 </span></p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>5.15除非已遵守了本協議的其它規定或已取得了我們事先許可，您不得為任何目的從事或幫助他人從事以下行為：</p>
                        <ul>
                          <li>
                            <div class="rt">（1）下載、複製、讀取、採用、展示、分享、轉發、傳播、上載、出版、發行我們的服務內容；</div>
                          </li>
                          <li>
                            <div class="rt">（2）修改、編輯、整理、編排或以其他方式演繹我們的服務內容；</div>
                          </li>
                          <li>
                            <div class="rt">（3）轉讓、轉售、出租我們的服務內容；</div>
                          </li>
                          <li>
                            <div class="rt">（4）採用包括但不限於特殊標識、特殊代碼等任何形式的識別方法，自行或協助第三人對我們服務的信息內容產生流量、閱讀量引導、轉移、劫持等不利影響。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>5.16經我們書面事先許可後，您對我們相關服務的信息內容的分享、轉發等行為，還應符合以下規範：</p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）對抓取、統計、獲得的相關搜索熱詞、命中率、分類、搜索量、點擊率、閱讀量等相關數據，未經我們事先書面同意，不得將上述數據以任何方式公示、提供、洩露給任何第三人；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）不得對本平台的源網頁進行任何形式的任何改動，包括但不限於本平台的首頁鏈接、廣告系統鏈接等入口，也不得對本平台的源頁面的展示進行任何形式的遮擋、插入、彈窗等妨礙；</div>
                          </li>
                          <li>
                            <div class="rt">（3）應當採取安全、有效、嚴密的措施，防止我們的信息內容被第三方通過包括但不限於網絡爬蟲程序等任何形式進行非法獲取；</div>
                          </li>
                          <li>
                            <div class="rt">（4）不得把相關數據內容用於我們書面許可範圍之外的目的，進行任何形式的銷售和商業使用，或向第三方洩露、提供或允許第三方為任何方式的使用；</div>
                          </li>
                          <li>
                            <div class="rt">（5）用戶向任何第三人分享、轉發我們相關服務信息內容的行為，還應遵守我們為此制定的其他規範和標準。 </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.17為了保護數據安全，您不得從事包括但不限於以下行為，也不得為其提供便利：
                        </p>
                        <ul>
                          <li>
                            <div class="rt">
                              （1）未經其他用戶明確同意，或在未向其他用戶如實披露數據用途、使用範圍等相關信息的情形下收集、複製、存儲、使用或傳輸其他用戶數據，侵害其他用戶合法權益；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （2）將其他用戶的帳號、暱稱等個人信息用於任何未經用戶及我們授權的用途；</div>
                          </li>
                          <li>
                            <div class="rt">（3）企圖進行反射查找、跟踪、關聯、挖掘、獲取用戶帳號、手機號和出生日期等個人信息；</div>
                          </li>
                          <li>
                            <div class="rt">（4）通過各種程序、軟件等抓取任何用戶的信息或與本服務相關的任何信息、數據；</div>
                          </li>
                          <li>
                            <div class="rt">（5）未經我們授權使用任何第三方軟件、插件、外掛、系統等查看、獲取本服務中所包含的我們及我們合作夥伴或用戶的任何相關信息、數據等內容；</div>
                          </li>
                          <li>
                            <div class="rt">
                              （6）其他危害數據安全的行為。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.18您在使用我們的服務時違反上述任何規定，我們可自行判斷並處理，要求您改正或採取一切必要的措施（包括但不限於刪除您上傳的內容、暫停或終止您使用本平台、刪除您的數字藏品圖像和描述、沒收您購買獲得的全部數字藏品）以減輕您不當行為造成的影響，且在任何時候有權在不進行任何事先通知的情況下終止向您提供服務，並追究相關責任。
                          <span class="bold">
                            違反上述任何規定產生任何法律後果的，應以您自己的名義獨立承擔所有的法律責任，造成我們損失或造成我們被第三人索賠的，您應全額賠償我們的一切損失和費用（包括但不限於各種賠償費、訴訟代理費及為此支出的其他合理費用）
                          </span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          5.19若您發現本平台內用戶發布的內容（包括但不限於圖片、視頻、文字作品等）侵犯您的在先權利，您可以通過info@mints.cn聯繫我們進行舉報，並提供相應的證明資料，我們核實後將及時採取措施制止侵權行為。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p class="bold">六、數字藏品的權利及限制</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          6.1您可以通過本平台購買由各領域的頂尖創作家創作的，登記在區塊鏈上，基於區塊鏈技術的加密性、不可篡改性和不可替代性，將區塊鏈登記作為其唯一的權屬憑證的<span
                            class="bold">數字藏品</span>按照本協議的約定獲取、購買數字藏品之後，您對數字藏品擁有的權利將受到限制，您僅可以將該數字藏品列入您的收藏欣賞、瀏覽及向其他用戶展示您的數字藏品。
                          <span
                            class="bold"> 數字藏品元數據中的創作者、創作和上鍊時間、購買者等信息，一經確認則不可篡改，當您購買數字藏品後，數字藏品所對應的包括購買者信息的區塊鏈登記將計入您的賬號並在我們運行和維護的【數字藏品權證登記鏈】進行登記，作為您持有該數字藏品的憑證，以實現您對數字藏品權利登記的不可篡改性和唯一性。您理解和同意，為了進行前述購買和登記，您的郵箱可能會被公開。此外，數字藏品在區塊鏈登記可能有一定延遲，您無法在購買後即時查看數字藏品的區塊鏈登記。在您購買數字藏品並完成登記後，您可通過您的賬號登錄本平台查看該數字藏品的區塊鏈登記權利憑證，但您無權要求提取該區塊鏈登記權利憑證或將區塊鏈登記權利憑證轉入您的其他電子錢包，亦無權要求我們將該數字藏品或其區塊鏈登記權利憑證導入至其他平台或在任何其他平台或機構對您的數字藏品進行登記。
                          </span>
                        </p>
                      </div>
                    </li>

                    <li>
                      <div class="rt">
                        <p>
                          6.2對於您根據本協議、通過本平台購買的數字藏品，權利人將授予您一項在版權有效期內的、非獨占的、非排他的、不可分許可的、僅限個人非商業目的用途的收藏、使用和展示您所購買的數字藏品的許可
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          6.3除本協議明確約定的內容以外，或者您另行取得著作權人及相關權利人書面授權，無論您通過本平台還是其他任何方式獲得數字藏品，我們和著作權人及相關權利人都不會授予您對數字藏品的任何權利和許可（包括但不限於著作權）。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p><span class="bold">6.4上文第6.2條授予的許可僅在您擁有數字藏品的時間範圍內適用。
                          </span>如果您註銷賬號或出於任何原因放棄您已購買的數字藏品，上文第6.2條授予的許可將立即到期，而無需另行通知。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt bold">
                        <p class="bold">6.5您不得，且不得允許任何第三方實施以下行為：</p>
                        <ul>
                          <li>
                            <div class="rt bold">（1）複製、分發、修改、改編、翻譯數字藏品，或以其他方式開發任何衍生作品；</div>
                          </li>
                          <li>
                            <div class="rt bold">
                              （2）將數字藏品用於任何商業目的，包括但不限於用於電影、視頻或任何其他形式的媒體、紙質或電子出版物（包括但不限於音視頻出版物）的封底、封面、插畫、內容、軟件或移動應用、線上或線下廣告、銷售或促銷，及其他任何形式的商業活動、廣告宣傳、數字藏品推廣等；
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">
                              （3）將數字藏品用於或關聯於任何違反國家法律法規、政策、社會公序良俗、色情淫穢、暴力殘忍、非法言論、不道德和/或侵犯第三人合法權利、權益的用途、場景；
                            </div>
                          </li>
                          <li>
                            <div class="rt bold">（4）將數字藏品（部分或全部）作為自身或其他第三方的商標、服務標記、標識、logo、原產地標識或其他商業標識；</div>
                          </li>
                          <li>
                            <div class="rt bold">（5）試圖為您所購買數字藏品註冊商標、版權或以其他方式獲得額外的知識產權；</div>
                          </li>
                          <li>
                            <div class="rt bold">（6）將數字藏品存儲在任何以共享、轉讓信息或內容為目的的平台、系統、互聯網、共享硬盤或類似設備上，供他人免費或付費瀏覽、下載、調取。
                            </div>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.6您理解並同意，由於購買行為一經發生即會被詳細地記錄在區塊鏈上，您在本平台購買數字藏品的行為是不可撤銷的，如您因認知錯誤、操作失誤、第三方欺詐等原因購買數字藏品，我們亦無法撤銷或恢復，您應對您的購買行為承擔全部責任。特別提醒您，本平台出售的數字藏品不支持七天無理由退換。一旦您購買數字藏品，您無權反悔要求退回、更換該數字藏品或退款。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.7您理解並同意，您在本平台上購買數字藏品的行為可能根據適用的法律法規產生一定的稅費，您應當負責按時支付全部稅費並承擔未履行相關義務時可能產生的全部法律責任。您無權從您應向我們或者其他用戶支付的款項中扣除稅費等其他額外產生的費用。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          6.8如果您購買的數字藏品包含第三方知識產權，您理解並同意，您無權在數字藏品之外使用第三方知識產權，例如：銷售、分銷包含第三方知識產權的商品。您使用數字藏品的權利可能受到第三方知識產權權利人的限制，您應當在我們向您書面通知此類限制時遵守的限制，否則，您應當承擔全部可能產生的法律後果和責任。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt bold">
                  <p>七、實物收藏品的數字證書之權利與限制</p>

                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          7.1您理解並同意，您通過本平台獲得的實物收藏品的數字證書，是登記在區塊鏈上，基於區塊鏈技術的加密性、不可篡改性和不可替代性，將區塊鏈登記作為持有該（等）實物收藏品的憑證。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.2實物收藏品的數字證書本身不具有交換價值，僅為確權工具，不得用於炒作、場外交易和任何商業用途。如發現您的賬號存在炒作實物收藏品的數字證書等異常行為、涉嫌違法違規或本協議禁止的行為，我們有權採取必要的限制措施，包含但不限於凍結您的賬號等。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.3當實物收藏品的所有權發生轉移時，實物收藏品的所有者可以在本平台申請該實物收藏品的數字證書的贈送，本平台在審核通過後將在合理時間內協助實物收藏品的持有者完成數字證書的轉移。為防止炒作，您理解並同意，您在獲得實物收藏品的數字證書需持有【180
                          】日方可贈送。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          7.4您理解並同意，鑑於區塊鏈服務的特殊性，本平台有權隨時關閉實物收藏品的數字證書的贈送功能。
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>八、知識產權保護</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          對於本平台的相關內容，我們將根據以下規則保護我們和您的知識產權：<br />
                          8.1除另有約定外，本平台的內容、代碼、數據等所有元素的所有權和所有法律權利、以及其中所有知識產品（包括但不限於數字藏品、系統、方法、信息、代碼、軟件、服務、組織、內容、數據、技術、程序、網頁、文字、圖片、圖表、外觀、外觀設計、簡報、應用程序，和所有其他元素的彙編）的知識產權及本平台上相關數據的權利均屬於我們所有。未經我們事先書面許可，您不能進行反向工程、反向彙編、反向編譯，或者以其他方式嘗試發現我們的源代碼，不能出租、出借、修改、鏈接、彙編、發表、出版、轉載、複製、拷貝、出售、轉售、訪問、爬取、建立鏡像站點或者使用任何部分的內容、數據、代碼和外觀設計。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.2我們尊重您的知識產權。為了向您提供我們的服務（例如：展示您上傳的文字、語音、圖片、視頻、圖文等），您同意授予我們一項全球的、免費的、可轉讓、非獨占和不可撤銷的權利，在不侵犯您商業秘密和個人信息的前提下，使用您在使用我們的服務中向我們提供或生成的所有信息和數據。除此之外，除非獲得了您的同意，我們不會擅自使用、修改、複製、公開傳播、改變、散佈、發行或公開發表您擁有知識產權的成果。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          8.3所有與本平台以及本平台內容相關的商標、服務標誌、編號均為我們或我們許可方的專有財產。未經我們事先書面授權同意，您不得在世界任何國家和地區將本平台Logo等文字、圖形及其組合，以及本平台的其他標識、商號、徽記、APP名稱、網站名稱、服務名稱、服務標記以任何方式展示、使用或申請註冊商標、進行域名註冊等，也不得實施向他人明示或暗示有權展示、使用、或其他有權處理上述標識的行為。如因您非法使用上述標識等給我們或他人造成損失的，由您承擔全部法律責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>
                          <span class="bold">
                            8.4您應尊重我們和第三方的知識產權和其他合法權利/權益，保證在使用本平台服務時上傳的文字、圖片、視頻、軟件以及表演等信息不侵犯任何第三方的知識產權、名譽權、姓名權、隱私權等合法權益，並保證在發生侵犯前述權益的違法事件時，保護我們及我們的僱員、股東、合作夥伴等免於因該等事件受到影響或損失。我們保留在您侵犯我們及/或其他第三方的合法權利/權益時終止向您提供服務並不退還任何款項的權利，您應自行承擔全部賠償責任，並且賠償我們因此遭受的包括但不限於經濟、企業商譽等損失。</span>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>8.5任何組織或個人認為本平台的內容侵犯其知識產權的，可通過info@mints.cn向我們提出書面權利通知和侵權的初步證據，我們將在收到知識產權權利人合格通知後依法盡快處理。
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>九、關於本軟件</p>
                  <p class="desc">
                    9.1我們開發並按照本協議之約定授權您下載、安裝、登錄、使用薄盒軟件（<span class="bold">“本軟件”</span>）。
                    <br>您可以通過手機終端以APP的形式使用本軟件，同時，我們會不斷豐富您使用本軟件的終端、形式等。當您使用本軟件時，您應選擇與您的終端、系統等相匹配的軟件版本，否則，您可能無法正常使用本軟件。
                  </p>
                  <p class="desc">
                    9.2我們授予您一項個人的、不可轉讓及非排他性的許可，以按照本協議及其他單項產品協議限定的範圍和方式使用本軟件。您且僅限於您個人，可為非商業目的在單一台終端設備上下載、安裝、使用、登錄本軟件。
                  </p>
                  <p class="desc">9.3您可以直接從我們的官方網站，以及授權的第三方網站和應用分發平台獲取本軟件。 </p>
                  <p class="desc bold">9.4如果您從未經我們授權的第三方獲取本軟件或與本軟件名稱相同的安裝程序，我們無法保證該軟件能夠正常使用，並對因此給您造成的損失不負任何責任。 </p>
                  <p class="desc">9.5我們可能為不同的終端、系統等開發不同的軟件版本，您應當根據實際情況選擇下載合適的版本進行安裝。下載安裝程序後，您需要按照該程序提示的步驟正確安裝。 </p>
                  <p class="desc">9.6如果您不再需要使用本軟件或者需要安裝新版軟件，可以自行卸載。如果您願意幫助我們改進產品服務，請告知我們卸載的原因。 </p>
                  <p class="desc">9.7為了增進用戶體驗、完善服務內容，我們可能不斷努力開發新的服務，並為您不時提供軟件更新。 </p>
                  <p class="desc bold">9.8為了改善用戶體驗或提高服務安全性、保證功能的一致性等目的，我們有權對本軟件進行更新，或者對本軟件的部分功能效果、服務內容進行改變。 </p>
                  <p class="desc">9.9本軟件新版本發布後，舊版本的軟件可能無法使用。我們不保證舊版本軟件繼續可用，也不保證繼續對舊版本軟件提供相應的客服和維護服務，請您隨時核對並下載最新版本。 </p>
                  <p class="desc">9.10本軟件可能會使用第三方軟件或技術（包括本軟件可能使用的開源代碼和公共領域代碼等，下同），這種使用已經獲得合法授權。 </p>
                  <p class="desc">
                    9.11本軟件如果使用了第三方的軟件或技術，我們將按照相關法規或約定，對相關的協議或其他文件，可能通過在本軟件安裝包特定文件夾中打包等形式進行展示，它們可能會以“軟件使用許可協議”“授權協議”“開源代碼許可證”或其他形式來表達。
                  </p>
                  <p class="desc">9.12前述相關協議或其他文件均是本協議不可分割的組成部分，與本協議具有同等的法律效力，您應當遵守這些要求。 <span
                      class="bold">如果您沒有遵守這些要求，該第三方或者國家機關可能會對您提起訴訟、進行罰款或採取其他制裁措施，並要求我們給予協助，您應當自行承擔法律責任。 </span></p>

                </div>
              </li>
              <li>
                <div class="rt">
                  <p>十、個人信息保護政策</p>
                  <p class="desc">
                    我們非常重視和保護您的個人信息，制定了專門的<span class="bold"><a href="/publicAgreement?agreementCode=H5YSZC"
                        style="color:#83878B;font-weight:bold">《薄盒隱私政策》</a></span>。在您使用我們提供的服務前，請您務必進行閱讀。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt">
                  <p>十一、賠償</p>
                  <p class="desc">
                    因您違反本協議而導致的任何第三方向我們或我們的關聯方提出的索賠或請求，您應當承擔賠償責任，包括但不限於訴訟費用、律師費用、差旅費用、和解金額、罰款或生效法律文書中規定的損害賠償金額、軟件使用費等，且您應為我們抗辯或消除影響，保護我們不受損害。
                  </p>
                </div>
              </li>
              <li>
                <div class="rt bold">
                  <p>十二、責任限制</p>
                  <p class="desc bold">請您知曉並理解，在以下情形中，我們不對由此給您造成的任何損失或損害承擔任何責任：</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.1我們將盡力為您提供暢通無阻、連貫安全的網絡服務，但網絡服務可能受多種因素的影響，我們不能保證向您提供的服務是連續的、即時的、準確的，也不能隨時預見和防範法律、技術以及其他風險，包括但不限於不可抗力、病毒、木馬、黑客攻擊、系統不穩定、第三方服務瑕疵、政府行為等原因可能導致的服務中斷、數據丟失、錢包文件損壞以及其他的損失和風險。我們的服務內容將依現狀提供，我們不作任何形式的有關服務內容的準確性、完整性、令人滿意的品質、不侵權或適合某一特殊目的的保證。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.2數字藏品購買的確認需要一定時間，且在某些情況下可能無法完成，例如硬件、軟件或網絡連接故障、惡意代碼或計算機病毒、支付系統、權證登記系統故障導致購買無法完成。在任何情況下我們無需對上述事項向您或任何第三方承擔責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.3我們保留隨時修改、增減、取消、暫停、中斷或終止提供本平台全部或部分服務而無需事先告知您的權利，亦無需對您和第三方承擔任何責任。服務器如因係統維護或升級而需暫停服務時，我們將盡量事先公告。如因係統維護、升級而需暫停服務或因服務器故障、硬件故障、其他不可抗力因素而導致停止服務，於暫停服務期間造成的一切不便和資料、數據等遺失，我們將盡力挽救恢復；如確實無法恢復，我們不承擔任何責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.4我們將盡可能地在服務中提供準確的信息。服務所涉及的數字藏品圖片、演示圖和示意圖僅供參考（圖片為合成圖、模擬演示圖）。限於篇幅，本協議中所包含的信息（包括但不限於數字藏品功能說明等）可能不完整，請以有關數字藏品使用說明書的具體信息為準。我們不保證提供的服務和數字藏品完全符合您的使用要求，或完全符合您的期望。我們保留隨時更改數字藏品的設計、規格的權利，而無需事先通知您。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.5對於您自本平台獲得的他人的信息、內容、聲明或者廣告宣傳等任何資訊，我們不負保證真實性、準確性、完整性以及合法性的責任。如果任何單位或者個人通過上述“信息”而進行任何行為，須自行甄別真偽和謹慎預防風險，否則，無論何種原因，我們不對任何非於本平台直接發生的交易和(或)行為承擔任何直接、間接、附帶或衍生的損失和責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.6我們不承擔由於您提供信息而可能產生的任何責任，包括但不限於因您在沒有獲得授權的情形下使用信息，或因您提供信息包含錯誤、不准確、病毒、誹謗、中傷、侵權等著作權法、隱私和個人信息保護相關法律或其他任何法律所禁止的內容或其他內容而產生的任何責任。我們亦不對您提供的信息在任何情形下的丟失、刪除、移除或傳輸失敗承擔任何責任，您應對其提供信息自行保留備份。我們保留隨時刪除或移除任何您提供信息的權利，而無需通知您，且不需承擔任何責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.7您知悉並同意，數字藏品的價值具有較大主觀性，我們或任何第三方對數字藏品目前及未來的價值均不作出任何承諾。您同意您將在不依賴我們服務的情況下獨立評估數字藏品的價格。區塊鏈登記權利憑證本身並不具有內在價值，僅為數字藏品的權利憑證，無法脫離數字藏品單獨購買，不得作為價值尺度或交易媒介使用用於購買其他資產，亦不得用於購買任何資產或單獨與國家法幣進行兌換。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.8我們的服務內容可能含有與第三方服務的鏈接或接入第三方提供的服務，這些第三方僅為您提供便利，不代表我們經營或參與經營這些服務，亦不代表您被授予訪問或使用這些服務的許可，您應自擔責任（包括但不限於遵守該第三方的使用條款）並自付費用訪問這些服務，我們不對這些服務的內容和行為負責。對於您在本平台之外，與第三方發生的任何法律行為，包括但不限於與第三方的交易，由您與該第三方自行承擔全部的責任，我們並不控製或支持此類交易，因此我們不承擔任何責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.9由於我們提供的產品和服務具有一定的創新性，當前的法律、法規、部門規章等規範性行文件、監管政策可能隨時發生變化並對我們提供的產品和服務產生重大影響。您知悉並同意，我們無法保證向您連續提供相關服務並維持您的數字藏品的初始價格，我們可能會根據需要更新或調整我們的服務內容，甚至中止、終止向您提供全部或部分服務。您認可並同意，為了保障交易安全、合法、有序以及履行我們反洗錢的義務，我們有權對您的區塊鏈地址進行安全查詢。如發現存在欺詐等異常情形，或您存在違反法律法規或本協議約定等情形，我們有權對您採取屏蔽或者限制使用等必要措施。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.10由於我們提供的數字藏品可能包含某些電視劇、電影、音樂、圖片、視聽作品等領域的片段，如果因為突發政策性要求導致全網範圍內下架某部作品或某人的作品，本平台將按照政策要求下架與其相關的數字藏品，您同意我們將不承擔相關責任。下架後，您可能無法購買以及公開展示該等數字藏品，但您已經購買的數字藏品仍可以在您的個人中心查看。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.11我們提供的產品和服務依賴於我們運行和維護的【數字藏品權證登記鏈】，所有智能合約在分散的賬本上執行和發生，我們對智能合約沒有控制權，也無法作出任何保證和承諾，您知悉並同意，我們不會對由此產生的任何後果和責任向您承擔法律責任。同時，我們對由於區塊鍊或流量網絡的任何其他功能或任何電子錢包造成的損失不承擔任何責任，包括但不限於開發者或代表最新報告的（或完全不報告）與區塊鏈有關的任何網絡問題，包括技術性節點問題或其他任何導致資金損失的問題。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.12您特此承認並接受：對於您因使用本服務而遭受的任何直接或間接的損失，包括但不限於由於服務內容或服務的延誤、不准確、錯誤和遺漏而產生的任何損害、責任、請求、損失或費用，我們及我們的關聯方不承擔任何責任。
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p class="bold">
                          12.13出於某些原因如公司經營策略調整等，我們可能會關閉本平台及所屬服務器，該行為將會導致您不能繼續通過本平台享受由我們向您提供的有關服務，如對數字藏品獨特的展示方式或針對數字藏品的有關服務等，您理解並同意，我們不會對由此產生的任何後果和責任向您承擔法律責任。但該行為不會導致您喪失已享有的數字藏品的有關權利，您持有數字藏品的相關信息仍然被記錄在相關區塊鏈上，您仍可以通過有關渠道查看您所持有的數字藏品，屆時我們會將有關渠道提供給您。
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>十三、法律適用與爭議解決</p>
                  <p class="desc">
                    本協議的解釋和執行均適用中華人民共和國法律。倘本協議之任何規定因與中華人民共和國法律抵觸而無效，則這些條款將盡可能接近本協議原條文意旨重新解析，且本協議其它規定仍應具有完整的效力及效果。如果本協議的內容與適用的強制性法律規定不一致，則以該強制性法律規定為準。
                    <span class="bold">因該協議的履行產生的任何糾紛，首先由雙方協商解決；協商不成的，任何一方均可向北京擘盒科技有限公司所在地有管轄權的人民法院提起訴訟。 </span>
                  </p>
                </div>
              </li>

              <li>
                <div class="rt">
                  <p>十四、其他條款</p>
                  <ul>
                    <li>
                      <div class="rt">
                        <p>
                          14.1您在使用我們的服務時，根據所涉及的服務內容，可能需要同時遵守其他協議或條款。本協議及其他協議或條款，共同構成我們與您之間關於使用我們的服務的完整協議。您僅在完全同意該完整協議的前提下，方可使用該有關的服務。

                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.2您和我們，即北京擘盒科技有限公司，雙方均是獨立的主體，在任何情況下本協議不構成雙方之間的代理、合夥、合營或僱傭關係。 </p>
                      </div>
                    </li>
                    <li>
                      <div class="rt">
                        <p>14.3本協議的解釋權及相關服務的解釋權歸北京擘盒科技有限公司所有。 </p>
                      </div>
                    </li>
                    <li>

                      <div class="rt">
                        <p>14.4本協議各標題僅供參考，不作為解釋條款內容的依據。 </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>

            </ul>
          </section>
        </article>

      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    mounted() {
      window.scrollTo(0, 0);
    }
  }

</script>

<style scoped="scoped">
  .contentTerms {
    background: #0C0C0C;
  }

  * {
    margin: 0;
    padding: 0;
  }

  a {
    word-break: break-all;
  }

  a:link {
    color: #5bb6fa;
  }

  /* 未被訪問的鏈接 */
  a:visited {
    color: #935171;
  }

  /* 已被訪問的鏈接 */
  a:hover {
    text-transform: uppercase;
  }

  /* 鼠標指針移動到鏈接上 */
  /* a:active {background:#FF704D;}  正在被點擊的鏈接 */

  li {
    list-style: none;
  }

  .content {
    /* padding-top: 56px; */
  }

  .intro {
    color: #BDBDBD;
    font-size: 12px;
  }

  .topTitle {
    color: #f5f4f9;
    font-size: 17px;
    font-weight: bold;
    text-align: center;
    display: inline-block;
    margin-bottom: 17px;
  }

  .topTitle img {
    width: 47px;
    height: 47px;
    object-fit: cover;
    display: inline-block;
    vertical-align: middle;
  }

  .content {
    /* position: absolute;
    top: 15px;
    right: 16px;
    left: 16px;
    bottom: 0;
    background-color: #0C0C0C;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px; */
  }

  .mainDiv {
    /* position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    bottom: 15px;
    overflow-y: scroll;
    padding: 15px 15px 0 15px;
    box-sizing: border-box;
    text-align: left; */

    padding: 10px;
    font-size: 14px;
    color: #8d8f9f;
    line-height: 1.75;
  }

  .main {}

  .privacy-content {
    color: #83878B;
    font-size: 12px;
  }

  .privacy-content ul li {
    /* display: flex;
    align-items: flex-start; */
  }

  .privacy-content>ul>li {}

  .privacy-content ul li .lf {
    text-align: right;
  }

  .privacy-content ul li .rt {
    text-align: left;
  }

  .privacy-content ul li p {}

  .privacy-content .desc {}

  .privacy-content .desc a {
    color: #83878b;
  }

  .bold {
    font-weight: bolder;
  }

</style>



// WEBPACK FOOTER //
// src/components/userAgreementTw.vue